"use strict";
exports.__esModule = true;
exports.MillenniumMonth = void 0;
var MillenniumMonth = /** @class */ (function () {
    function MillenniumMonth(absoluteMonthNumber, representation) {
        this.absoluteMonthNumber = absoluteMonthNumber;
        this.representation = representation;
    }
    MillenniumMonth.prototype.getRepresentation = function () {
        return this.representation;
    };
    MillenniumMonth.prototype.getAbsoluteMonthNumber = function () {
        return this.absoluteMonthNumber;
    };
    MillenniumMonth.prototype.equals = function (obj) {
        if (this === obj) {
            return true;
        }
        if (obj === null || obj === undefined) {
            return false;
        }
        if (!(obj instanceof MillenniumMonth)) {
            return false;
        }
        return this.absoluteMonthNumber === obj.absoluteMonthNumber;
    };
    MillenniumMonth.JANUARY = new MillenniumMonth(0, "jan");
    MillenniumMonth.FEBRUARY = new MillenniumMonth(1, "feb");
    MillenniumMonth.MARCH = new MillenniumMonth(2, "mar");
    MillenniumMonth.APRIL = new MillenniumMonth(3, "apr");
    MillenniumMonth.MAY = new MillenniumMonth(4, "may");
    MillenniumMonth.JUNE = new MillenniumMonth(5, "jun");
    MillenniumMonth.JULY = new MillenniumMonth(6, "jul");
    MillenniumMonth.AUGUST = new MillenniumMonth(7, "aug");
    MillenniumMonth.SEPTEMBER = new MillenniumMonth(8, "sep");
    MillenniumMonth.OCTOBER = new MillenniumMonth(9, "oct");
    MillenniumMonth.NOVEMBER = new MillenniumMonth(10, "nov");
    MillenniumMonth.DECEMBER = new MillenniumMonth(11, "dec");
    return MillenniumMonth;
}());
exports.MillenniumMonth = MillenniumMonth;
